<template>
  <div class="main-panel">
    <div class="content-wrapper bancos-shell">
      <div class="cardplay bancos-config-shell">
        <div class="row bancos-header g-3 align-items-center">
          <div class="col-12 col-lg-8">
            <h2 class="bancos-title mb-1">Bancos</h2>
            <p class="bancos-subtitle mb-0">Configura bancos y numeros de cuenta para registrar pagos.</p>
          </div>
          <div class="col-12 col-lg-4 d-flex justify-content-lg-end">
            <button class="btn btn-primary bancos-main-btn" type="button" @click="openCreate">
              <i class="fa-solid fa-plus"></i>
              Nuevo Banco
            </button>
          </div>
        </div>

        <div v-if="showForm" class="form-card">
          <div class="form-card-header">
            <div>
              <h5 class="mb-1">{{ formTitle }}</h5>
              <span>{{ form.cuentas.length }} cuenta(s)</span>
            </div>
            <button class="btn btn-light icon-btn" type="button" @click="closeForm">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <form @submit.prevent="saveBanco">
            <div class="row g-3">
              <div class="col-12 col-lg-5">
                <label class="form-label" for="nombreBanco">Nombre del Banco</label>
                <input
                  id="nombreBanco"
                  v-model.trim="form.nombreBanco"
                  class="form-control"
                  type="text"
                  required
                />
              </div>
              <div class="col-12 col-lg-7">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <label class="form-label mb-0">Numeros de cuenta</label>
                  <button class="btn btn-outline-secondary btn-sm add-account-btn" type="button" @click="addCuenta">
                    <i class="fa-solid fa-plus"></i>
                    Agregar cuenta
                  </button>
                </div>
                <div class="cuentas-list">
                  <div v-for="(cuenta, index) in form.cuentas" :key="index" class="cuenta-row">
                    <input
                      v-model.trim="form.cuentas[index]"
                      class="form-control"
                      type="text"
                      required
                    />
                    <button class="btn btn-light icon-btn" type="button" @click="removeCuenta(index)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-actions">
              <button class="btn btn-light bancos-secondary-btn" type="button" @click="closeForm">Cancelar</button>
              <button class="btn btn-primary bancos-save-btn" type="submit" :disabled="saving">
                <span v-if="saving" class="spinner-border spinner-border-sm" role="status"></span>
                Guardar Banco
              </button>
            </div>
          </form>
        </div>

        <div class="table-card">
          <div v-if="!ready" class="loading-shell">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            Cargando bancos...
          </div>

          <div v-else-if="bancos.length === 0" class="empty-shell">
            No hay bancos configurados.
          </div>

          <div v-else class="table-responsive horizontal-scrollable">
            <table class="table table-compact table-striped align-middle bancos-table">
              <thead>
                <tr>
                  <th>Banco</th>
                  <th>Numeros de cuenta</th>
                  <th>Estado</th>
                  <th class="text-end">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="banco in bancos" :key="banco.id">
                  <td class="bank-name">{{ banco.nombreBanco }}</td>
                  <td>
                    <div class="account-tags">
                      <span v-for="cuenta in banco.cuentas" :key="cuenta" class="account-tag">
                        {{ cuenta }}
                      </span>
                    </div>
                  </td>
                  <td>
                    <span class="badge bg-success banco-badge">Activo</span>
                  </td>
                  <td>
                    <div class="table-actions">
                      <button class="btn btn-light icon-btn" type="button" @click="editBanco(banco)">
                        <i class="fa-solid fa-pen-to-square"></i>
                      </button>
                      <button class="btn btn-light icon-btn danger" type="button" @click="deleteBanco(banco)">
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Security from "../security";

export default {
  data() {
    return {
      bancos: [],
      ready: false,
      saving: false,
      showForm: false,
      form: {
        id: 0,
        nombreBanco: "",
        cuentas: [""],
        activo: true,
      },
    };
  },
  computed: {
    formTitle() {
      return this.form.id > 0 ? "Editar Banco" : "Nuevo Banco";
    },
  },
  beforeMount() {
    Security.requireToken();
    this.fetchBancos();
  },
  methods: {
    emptyForm() {
      return {
        id: 0,
        nombreBanco: "",
        cuentas: [""],
        activo: true,
      };
    },
    fetchBancos() {
      this.ready = false;
      fetch(
        process.env.VUE_APP_API_URL + "/admin/bancos/all",
        Security.requestOptions({})
      )
        .then((response) => this.readJSONResponse(response))
        .then((response) => {
          if (response.error) {
            this.showError(response.message);
            return;
          }

          this.bancos = response.data?.bancos || [];
        })
        .catch((error) => {
          this.showError(error);
        })
        .finally(() => {
          this.ready = true;
        });
    },
    openCreate() {
      this.form = this.emptyForm();
      this.showForm = true;
    },
    closeForm() {
      this.form = this.emptyForm();
      this.showForm = false;
      this.saving = false;
    },
    editBanco(banco) {
      this.form = {
        id: banco.id,
        nombreBanco: banco.nombreBanco,
        cuentas: banco.cuentas?.length ? [...banco.cuentas] : [""],
        activo: banco.activo !== false,
      };
      this.showForm = true;
    },
    addCuenta() {
      this.form.cuentas.push("");
    },
    removeCuenta(index) {
      if (this.form.cuentas.length === 1) {
        this.form.cuentas = [""];
        return;
      }

      this.form.cuentas.splice(index, 1);
    },
    saveBanco() {
      const payload = {
        id: this.form.id,
        nombreBanco: this.form.nombreBanco.trim(),
        cuentas: this.form.cuentas.map((cuenta) => cuenta.trim()).filter(Boolean),
        activo: true,
      };

      if (payload.nombreBanco === "" || payload.cuentas.length === 0) {
        this.showError("Completa el nombre del banco y al menos una cuenta.");
        return;
      }

      this.saving = true;
      fetch(
        process.env.VUE_APP_API_URL + "/admin/bancos/save",
        Security.requestOptions(payload)
      )
        .then((response) => this.readJSONResponse(response))
        .then((response) => {
          if (response.error) {
            this.showError(response.message);
            return;
          }

          this.closeForm();
          this.fetchBancos();
          Swal.fire({
            icon: "success",
            title: "Banco guardado",
            showConfirmButton: false,
            timer: 1200,
          });
        })
        .catch((error) => {
          this.showError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    deleteBanco(banco) {
      Swal.fire({
        title: "Eliminar banco",
        text: banco.nombreBanco,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        fetch(
          process.env.VUE_APP_API_URL + "/admin/bancos/delete",
          Security.requestOptions({ id: banco.id })
        )
          .then((response) => this.readJSONResponse(response))
          .then((response) => {
            if (response.error) {
              this.showError(response.message);
              return;
            }

            this.fetchBancos();
          })
          .catch((error) => {
            this.showError(error);
          });
      });
    },
    readJSONResponse(response) {
      return response.text().then((text) => {
        if (!text) {
          return {};
        }

        try {
          return JSON.parse(text);
        } catch (error) {
          throw new Error(text);
        }
      });
    },
    showError(message) {
      Swal.fire({
        icon: "error",
        title: "No se pudo completar",
        text: String(message),
      });
    },
  },
};
</script>

<style scoped>
.bancos-shell {
  background: linear-gradient(165deg, #f6f7fa 0%, #edf0f5 48%, #fafafa 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 22px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 22px 54px rgba(15, 23, 42, 0.07);
}

.bancos-header {
  background: linear-gradient(120deg, #20242b 0%, #343a43 72%, #4b5563 100%);
  border-radius: 16px;
  color: #fff;
  padding: 14px 16px;
  margin-bottom: 18px;
}

.bancos-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.2px;
  margin: 0;
}

.bancos-subtitle {
  color: #e5e7eb;
  font-size: 0.93rem;
}

.bancos-main-btn,
.bancos-save-btn,
.bancos-secondary-btn {
  border-radius: 10px;
  min-height: 38px;
  padding-inline: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.form-card,
.table-card {
  background: #ffffff;
  border: 1px solid #e3e7ee;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
  padding: 14px;
}

.form-card {
  margin-bottom: 16px;
}

.form-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #edf0f5;
  padding-bottom: 12px;
  margin-bottom: 14px;
}

.form-card-header h5 {
  color: #111827;
  font-weight: 700;
}

.form-card-header span {
  color: #6b7280;
  font-size: 0.86rem;
}

.form-label {
  color: #374151;
  font-size: 0.88rem;
  font-weight: 700;
}

.form-control {
  border-color: #dce1e8;
  border-radius: 9px;
  min-height: 38px;
}

.cuentas-list {
  display: grid;
  gap: 8px;
}

.cuenta-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 38px;
  gap: 8px;
}

.icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  border: 1px solid #e5e7eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #374151;
}

.icon-btn.danger {
  color: #b91c1c;
}

.add-account-btn {
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 600;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.horizontal-scrollable {
  overflow-x: auto;
  white-space: nowrap;
}

.bancos-table thead th {
  background: #f3f5f8;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.86rem;
}

.bancos-table td {
  vertical-align: middle;
}

.bank-name {
  color: #111827;
  font-weight: 700;
}

.account-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  white-space: normal;
}

.account-tag {
  background: #eef2f7;
  border: 1px solid #e1e6ee;
  border-radius: 999px;
  color: #334155;
  font-size: 0.82rem;
  padding: 4px 9px;
}

.banco-badge {
  border-radius: 999px;
  padding: 0.36rem 0.64rem;
}

.table-actions {
  display: flex;
  justify-content: flex-end;
  gap: 7px;
}

.loading-shell,
.empty-shell {
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  min-height: 120px;
}

@media (max-width: 767px) {
  .cardplay {
    border-radius: 16px;
    padding: 14px;
  }

  .form-actions {
    flex-direction: column;
  }

  .bancos-main-btn,
  .bancos-save-btn,
  .bancos-secondary-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
